
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#464646","fill-rule":"evenodd","d":"M5.001 18h10.111v-1.998H5.002V18zm1.92-10.389a1.225 1.225 0 01-1.591 0 .922.922 0 010-1.413L10.057 2l4.724 4.198a.922.922 0 010 1.413 1.19 1.19 0 01-.793.293 1.19 1.19 0 01-.796-.293l-2.01-1.787v8.18h-2.25v-8.18l-2.01 1.787z"}})])
          )
        }
      }
    